/**
 * API Endpoints - Organized by feature/domain
 * Add your endpoints here as you implement them
 */

export const ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REGISTER: '/auth/register',
    REFRESH: '/auth/refresh',
    VERIFY_WALLET: '/auth/verify-wallet',
    TWITTER_INITIATE: '/auth/twitter/initiate',
    TWITTER_CALLBACK: '/auth/twitter/callback',
    TWITTER_DISCONNECT: '/auth/twitter/disconnect',
    DISCORD_INITIATE: '/auth/discord/initiate',
    DISCORD_CALLBACK: '/auth/discord/callback',
    DISCORD_DISCONNECT: '/auth/discord/disconnect',
    TELEGRAM_INITIATE: '/auth/telegram/initiate',
    TELEGRAM_CALLBACK: '/auth/telegram/callback',
    TELEGRAM_DISCONNECT: '/auth/telegram/disconnect',
    GET_NONCE: (address) => `/auth/${address}/nonce`,
    VALIDATE_NONCE: '/auth/validate/nonce',
  },

  // User/Profile endpoints
  USER: {
    PROFILE: '/user/profile',
    UPDATE_PROFILE: '/user/profile',
    STATS: '/user/stats',
    WALLET: '/user/wallet',
    TOP: '/user/top',
    INFO: '/users/info',
  },

  // Mindshare endpoints
  MINDSHARE: {
    LEADERBOARD: '/mindshare/leaderboard',
    CONTRIBUTORS: '/mindshare/contributors',
    USER_SCORE: '/mindshare/score',
  },

  // Quests endpoints
  QUEST: {
    LIST: '/quest',
    DETAILS: (id) => `/quest/${id}`,
    COMPLETE: (id) => `/quest/${id}/complete`,
    BY_USER: '/quest/user/:userAddress',
    USER_QUEST_STATUS: (questId, userAddress) => `/quest/${questId}/user/${userAddress}`,
  },

  // Multipliers endpoints
  MULTIPLIERS: {
    LIST: '/multipliers',
    USER_MULTIPLIERS: '/multipliers/user',
  },

  // DAO endpoints
  DAO: {
    PROPOSALS: '/dao/proposals',
    BOUNTIES: '/dao/bounties',
    VOTES: '/dao/votes',
  },

  // Job endpoints
  JOB: {
    INFO: (jobId) => `/job/${jobId}/info`,
  },

  // Referral endpoints
  REFERRAL: {
    STATS: '/referral/stats',
    CONNECTIONS: '/referral/connections',
  },
};

export default ENDPOINTS;
